import { useMemo } from 'react';

import {
  useOidcAccessToken,
  useOidcIdToken,
  useOidcUser,
} from '@axa-fr/react-oidc';
import { FlyOidcUser, FlyUser, getFirstLetter } from '@fly/shared';

export const useUser = (): FlyUser => {
  const { oidcUser, oidcUserLoadingState } = useOidcUser<FlyOidcUser>();
  const { idToken, idTokenPayload } = useOidcIdToken();

  const tenant = idTokenPayload?.tenant;

  const username = oidcUser?.username || '';
  const email = oidcUser?.email || '';
  const udid = oidcUser?.sub || '';
  const { accessTokenPayload, accessToken } = useOidcAccessToken();

  return useMemo(() => {
    const firstLetterUserName = getFirstLetter(username);
    return {
      username,
      email,
      firstLetterUserName,
      idToken,
      accessTokenPayload,
      accessToken,
      oidcUserLoadingState,
      tenant,
      udid,
    };
  }, [
    tenant,
    accessTokenPayload,
    username,
    email,
    idToken,
    accessToken,
    oidcUserLoadingState,
    udid,
  ]);
};
